import { t } from "i18next";
import { PersonInfo } from "ui";

import { ReturnPersonInfoAtomProps } from "../ReturnsTable.types";

import styles from "../ReturnsTable.module.scss";

const getUrl = (imageUrl?: string | null) => {
  if (imageUrl) return { url: imageUrl };
  return null;
};

export const OrderPersonCell = ({
  imageUrl,
  name
}: ReturnPersonInfoAtomProps) => {
  return name ? (
    <PersonInfo
      image={getUrl(imageUrl)}
      personName={name}
      nameClassName={styles.returnsTable_name}
      wrapperClassName={styles.returnsTable_nameWrapper}
      dimensions={{ width: 24, height: 24, borderRadius: "100px" }}
    />
  ) : (
    <p className={styles.returnsTable_noPersonLabel}>{t("Not assigned")}</p>
  );
};
